/**
 * @file Shared Recalls modal layout classes.
 */

export const RECALLS_MODAL_BODY_SPACING_CLASSES = "pb-3";
export const RECALLS_MODAL_GRID_CLASSES = "grid grid-cols-1 gap-4 md:grid-cols-2";
export const RECALLS_MODAL_STACK_CLASSES = `space-y-4 ${RECALLS_MODAL_BODY_SPACING_CLASSES} text-left`;

/**
 * Applies the standard Recalls modal processing affordance to an action button.
 * @param {HTMLButtonElement|null} button Modal action button.
 * @param {boolean} isProcessing Whether the button is processing.
 * @param {object} [options={}] Processing label options.
 * @param {string} [options.processingLabel="Saving..."] Label while pending.
 * @param {string} [options.idleLabel] Label when processing ends.
 * @returns {void}
 */
export function setRecallsModalActionProcessing(
    button,
    isProcessing,
    { idleLabel = "", processingLabel = "Saving..." } = {},
) {
    if (!button) {return;}
    if (isProcessing && !button.dataset.recallModalIdleLabel) {
        button.dataset.recallModalIdleLabel = button.textContent || "";
    }
    button.disabled = isProcessing;
    button.textContent = isProcessing ?
        processingLabel :
        (idleLabel || button.dataset.recallModalIdleLabel || button.textContent);
    button.classList.toggle("opacity-70", isProcessing);
    button.classList.toggle("cursor-wait", isProcessing);
    button.classList.toggle("cursor-not-allowed", isProcessing);
    if (!isProcessing && idleLabel) {
        button.dataset.recallModalIdleLabel = idleLabel;
    }
}
